"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = _interopRequireDefault(require("../enums.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const componentNames = ['control', 'controlKnob', 'controlVoid'];
const config = {
  expressions: [_enums.default.expressions.CRITICAL],
  interactions: [_enums.default.interactions.FOCUSED, _enums.default.interactions.HOVERED, _enums.default.interactions.CHOSEN],
  styleProperties: [_enums.default.properties.BACKGROUND_COLOR, _enums.default.properties.FOREGROUND_COLOR, _enums.default.properties.BORDER_COLOR, _enums.default.properties.OUTLINE_COLOR, _enums.default.properties.BORDER_RADIUS, _enums.default.properties.BORDER_WIDTH]
};
var _default = exports.default = componentNames.reduce((obj, name) => Object.assign(obj, {
  [name]: config
}), {});